export default [
  {
    "id": "mat-enem-0086",
    "numero": 1586,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Joana frequenta uma academia de ginástica \nonde faz exercícios de musculação. O programa \nde Joana requer que ela faça 3 séries de exer-\ncícios em 6 aparelhos diferentes, gastando 30 \nsegundos em cada série. No aquecimento, ela \ncaminha durante 10 minutos na esteira e des-\ncansa durante 60 segundos para começar o \nprimeiro exercício no primeiro aparelho. Entre \numa série e outra, assim como ao mudar de \naparelho, Joana descansa por 60 segundos.  \n \nSuponha que, em determinado dia, Joana tenha \niniciado seus exercícios às 10h30min e finaliza-\ndo às 11h7min. Nesse dia e nesse tempo, Joa-\nna: \n \nA) não poderia fazer sequer a metade dos exer-\ncícios e dispor dos períodos de descanso espe-\ncificados em seu programa. \nB) poderia ter feito todos os exercícios e cum-\nprido rigorosamente os períodos de descanso \nespecificados em seu programa. \nC) poderia ter feito todos os exercícios, mas \nteria de ter deixado de cumprir um dos períodos \nde descanso especificados em seu programa. \nD) conseguiria fazer todos os exercícios e cum-\npriria todos os períodos de descanso especifi-\ncados em seu programa, e ainda se permitiria \numa pausa de 7 min. \nE) não poderia fazer todas as 3 séries dos exer-\ncícios especificados em seu programa; em al-\nguma dessas séries deveria ter feito uma série a \nmenos e não deveria ter cumprido um dos perí-\nodos de descanso.",
    "alternativas": {
      "A": "não poderia fazer sequer a metade dos exer- cícios e dispor dos períodos de descanso espe- cificados em seu programa.",
      "B": "poderia ter feito todos os exercícios e cum- prido rigorosamente os períodos de descanso especificados em seu programa.",
      "D": "conseguiria fazer todos os exercícios e cum- priria todos os períodos de descanso especifi- cados em seu programa, e ainda se permitiria uma pausa de 7 min.",
      "E": "não poderia fazer todas as 3 séries dos exer- cícios especificados em seu programa; em al- guma dessas séries deveria ter feito uma série a menos e não deveria ter cumprido um dos perí- odos de descanso."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 86,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0087",
    "numero": 1587,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Um artesão construiu peças de artesanato inter-\nceptando uma pirâmide de base quadrada com \num plano. Após fazer um estudo das diferentes \npeças que poderia obter, ele concluiu que uma \ndelas poderia ter uma das faces pentagonal.  \n \nQual dos argumentos a seguir justifica a conclu-\nsão do artesão? \n \nA) Uma pirâmide de base quadrada tem 4 ares-\ntas laterais e a interseção de um plano com a \npirâmide intercepta suas arestas laterais. Assim, \nesses pontos formam um polígono de 4 lados. \nB) Uma pirâmide de base quadrada tem 4 faces \ntriangulares e, quando um plano intercepta essa \npirâmide, divide cada face em um triângulo e um \ntrapézio. Logo, um dos polígonos tem 4 lados. \nC) Uma pirâmide de base quadrada tem 5 faces \ne a interseção de uma face com um plano é um \nsegmento de reta. Assim, se o plano interceptar \ntodas as faces, o polígono obtido nessa interse-\nção tem 5 lados. \nD) O número de lados de qualquer polígono \nobtido como interseção de uma pirâmide com \num plano é igual ao número de faces da pirâmi-\nde. Como a pirâmide tem 5 faces, o polígono \ntem 5 lados. \nE) O número de lados de qualquer polígono \nobtido interceptando-se uma pirâmide por um \nplano é igual ao número de arestas laterais da \npirâmide. Como a pirâmide tem 4 arestas late-\nrais, o polígono tem 4 lados.",
    "alternativas": {
      "A": "Uma pirâmide de base quadrada tem 4 ares- tas laterais e a interseção de um plano com a pirâmide intercepta suas arestas laterais. Assim, esses pontos formam um polígono de 4 lados.",
      "B": "Uma pirâmide de base quadrada tem 4 faces triangulares e, quando um plano intercepta essa pirâmide, divide cada face em um triângulo e um trapézio. Logo, um dos polígonos tem 4 lados.",
      "C": "Uma pirâmide de base quadrada tem 5 faces e a interseção de uma face com um plano é um segmento de reta. Assim, se o plano interceptar todas as faces, o polígono obtido nessa interse- ção tem 5 lados.",
      "E": "O número de lados de qualquer polígono obtido interceptando-se uma pirâmide por um plano é igual ao número de arestas laterais da pirâmide. Como a pirâmide tem 4 arestas late- rais, o polígono tem 4 lados."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 87,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0088",
    "numero": 1588,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "João deve 12 parcelas de R$ 150,00 referentes \nao cheque especial de seu banco e cinco parce-\nlas de R$ 80,00 referentes ao cartão de crédito. \nO gerente do banco lhe ofereceu duas parcelas \nde desconto no cheque especial, caso João \nquitasse esta dívida imediatamente ou, na \nmesma condição, isto é, quitação imediata, com \n25% de desconto na dívida do cartão. João \ntambém poderia renegociar suas dívidas em 18 \nparcelas mensais de R$ 125,00. Sabendo des-\nses termos, José, amigo de João, ofereceu-lhe \nemprestar o dinheiro que julgasse necessário \npelo tempo de 18 meses, com juros de 25% \nsobre o total emprestado. \n \nA opção que dá a João o menor gasto seria: \n \nA) renegociar suas dívidas com o banco. \nB) pegar emprestado de José o dinheiro refe-\nrente à quitação das duas dívidas. \nC) recusar o empréstimo de José e pagar todas \nas parcelas pendentes nos devidos prazos. \nD) pegar emprestado de José o dinheiro refe-\nrente à quitação do cheque especial e pagar as \nparcelas do cartão de crédito. \nE) pegar emprestado de José o dinheiro refe-\nrente à quitação do cartão de crédito e pagar as \nparcelas do cheque especial.",
    "alternativas": {
      "A": "renegociar suas dívidas com o banco.",
      "B": "pegar emprestado de José o dinheiro refe- rente à quitação das duas dívidas.",
      "C": "recusar o empréstimo de José e pagar todas as parcelas pendentes nos devidos prazos.",
      "E": "pegar emprestado de José o dinheiro refe- rente à quitação do cartão de crédito e pagar as parcelas do cheque especial."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 88,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0089",
    "numero": 1589,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A cisterna é um recipiente utilizado para arma-\nzenar água da chuva. Os principais critérios a \nserem observados para captação e armazena-\ngem de água da chuva são: a demanda diária \nde água na propriedade; o índice médio de pre-\ncipitação (chuva), por região, em cada período \ndo ano; o tempo necessário para armazenagem; \ne a área de telhado necessária ou disponível \npara captação. Para fazer o cálculo do volume \nde uma cisterna, deve-se acrescentar um adici-\nonal relativo ao coeficiente de evaporação. Na \ndificuldade em se estabelecer um coeficiente \nconfiável, a Empresa Brasileira de Pesquisa \nAgropecuária (EMBRAPA) sugere que sejam \nadicionados 10% ao volume calculado de água. \n \nDesse modo, o volume, em m3, de uma cisterna \né calculado por Vc = Vd × Ndia, em que Vd = vo-\nlume de demanda da água diária (m3), Ndia = \nnúmero de dias de armazenagem, e este resul-\ntado deve ser acrescido de 10%. Para melhorar \na qualidade da água, recomenda-se que a cap-\ntação seja feita somente nos telhados das edifi-\ncações. \n \nConsiderando que a precipitação de chuva de 1 \nmm sobre uma área de 1 m² produz 1 litro de \nágua, pode-se calcular a área de um telhado a \nfim de atender a necessidade de armazenagem \nda seguinte maneira: área do telhado (em m²) = \nvolume da cisterna (em litros)/precipitação. \n \nPara atender a uma demanda diária de 2.000 \nlitros de água, com período de armazenagem de \n15 dias e precipitação média de 110 mm, o te-\nlhado, retangular, deverá ter as dimensões mí-\nnimas de: \n \nA) 6 metros por 5 metros, pois assim teria uma \nárea de 30 m². \nB) 15 metros por 20 metros, pois assim teria \numa área de 300 m². \nC) 50 metros por 60 metros, pois assim teria \numa área de 3.000 m². \nD) 91 metros por 30 metros, pois assim teria \numa área de 2.730 m². \nE) 110 metros por 30 metros, pois assim teria \numa área de 3.300 m².",
    "alternativas": {
      "D": "91 metros por 30 metros, pois assim teria uma área de 2.730 m².",
      "A": "6 metros por 5 metros, pois assim teria uma área de 30 m².",
      "B": "15 metros por 20 metros, pois assim teria uma área de 300 m².",
      "C": "50 metros por 60 metros, pois assim teria uma área de 3.000 m²."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 89,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0090",
    "numero": 1590,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Um médico está estudando um novo medica-\nmento que combate um tipo de câncer em está-\ngios avançados. Porém, devido ao forte efeito \ndos seus componentes, a cada dose adminis-\ntrada há uma chance de 10% de que o paciente \nsofra algum dos efeitos colaterais observados \nno estudo, tais como dores de cabeça, vômitos \nou mesmo agravamento dos sintomas da doen-\nça. O médico oferece tratamentos compostos \npor 3, 4, 6, 8 ou 10 doses do medicamento, de \nacordo com o risco que o paciente pretende \nassumir.  \n \nSe um paciente considera aceitável um risco de \naté 35% de chances de que ocorra algum dos \nefeitos colaterais durante o tratamento, qual é o \nmaior número admissível de doses para esse \npaciente? \n \nA) 3 doses.         \nB) 4 doses.        \nC) 6 doses.        \nD) 8 doses.       \nE) 10 doses.",
    "alternativas": {
      "C": "6 doses.",
      "D": "8 doses.",
      "E": "10 doses.",
      "B": "4 doses."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 90,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0091",
    "numero": 1591,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Após observar o aumento mensal na conta de \nluz de sua residência, um consumidor colocou \nem um gráfico de barras, mostrado a seguir, os \nvalores dos pagamentos realizados nos últimos \nquatro meses. \n \n \n \nSe o aumento observado prosseguir mensal-\nmente, quanto esse consumidor deverá pagar \nem junho desse mesmo ano? \n \nA) R$ 100,50 \nB) R$ 111,00 \nC) R$ 62,50 \nD) R$ 76,50 \n \nE) R$ 55,00",
    "alternativas": {
      "C": "R$ 62,50",
      "D": "R$ 76,50",
      "E": "R$ 55,00",
      "A": "R$ 100,50"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 91,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0093",
    "numero": 1593,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O \"Torcidômetro\" é uma ferramenta para se \nentender a dinâmica do crescimento ou enco-\nlhimento das torcidas dos times de futebol no \npaís. O gráfico abaixo mostra a variação per-\ncentual, entre 1993 e 2007, das torcidas de \ncinco times, numerados em: I, II, III, IV e V. \n \n \n \nOs dados exibidos no gráfico indicam que a \ntorcida que cresceu, entre fevereiro de 2006 e \nagosto de 2007, foi a torcida do time: \n \nA) III. \nB) I. \nC) V. \nD) IV. \nE) II.",
    "alternativas": {
      "B": "I.",
      "C": "V.",
      "D": "IV.",
      "A": "III."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 93,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0094",
    "numero": 1594,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Tragédias, causadas pelas forças da natureza \nou pelo homem, acontecem em todo lugar. Na \nmaioria das vezes, nem há como prevê-las, mas \nmuitas vezes elas acontecem pela falta de re-\ncursos para evitá-las, pela falta de infraestrutura \npara minorar suas consequências ou simples-\nmente por ignorância da população e falta de \numa política de segurança mais rígida. \n \nA seguir, tem-se um gráfico que mostra a esta-\ntística de naufrágios de navios nas costas brasi-\nleiras. \n \n \nDados extraídos em 01.05 \n1905 naufrágios no SINAU \n \nObservando o gráfico, é correto afirmar que os \ntipos de acidentes que estão acima da média de \nacidentes são: \n \nA) encalhe, choque, guerra e mau tempo. \nB) acidentes diversos, incêndios e explosão. \nC) encalhe, choque e guerra. \nD) guerra, mau tempo e acidentes diversos. \nE) incêndio e explosão.",
    "alternativas": {
      "D": "guerra, mau tempo e acidentes diversos.",
      "A": "encalhe, choque, guerra e mau tempo.",
      "B": "acidentes diversos, incêndios e explosão.",
      "C": "encalhe, choque e guerra."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 94,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0095",
    "numero": 1595,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "João é morador de Brasília, a capital do Brasil. \nEle mora na SQN 202, trabalha na SQN 204, e \npercorre diariamente o trajeto indicado no mapa \nabaixo, seguindo de A até B. \n \n \n \nOrientando-se pelos pontos cardeais desenha-\ndos no mapa, qual é a orientação da trajetória \nque João deve seguir desde sua residência até \nseu local de trabalho? \n \nA) Oeste, Leste, Oeste. \nB) Leste, Leste, Norte, Oeste. \nC) Oeste, Sul, Oeste, Norte, Oeste. \nD) Leste, Sul, Leste, Norte, Oeste. \nE) Oeste, Norte, Oeste.",
    "alternativas": {
      "B": "Leste, Leste, Norte, Oeste.",
      "C": "Oeste, Sul, Oeste, Norte, Oeste.",
      "D": "Leste, Sul, Leste, Norte, Oeste.",
      "E": "Oeste, Norte, Oeste."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 95,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0096",
    "numero": 1596,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Nas últimas décadas, desencadeou-se uma \ndiscussão quanto ao papel da Amazônia no \nequilíbrio da biosfera e sobre as consequências \nque sua devastação poderá trazer para o clima \ndo planeta. No gráfico a seguir, está represen-\ntada, em quilômetros quadrados, a evolução da \nárea que foi desmatada na floresta amazônica \nentre 1988 e 2007. \n \n \n \nDe acordo com os dados, o biênio em que ocor-\nreu o maior desmatamento acumulado foi: \n \nA) 1988–1989. \nB) 1994–1995. \nC) 1995–1996. \nD) 2003–2004. \nE) 2000–2001.",
    "alternativas": {
      "C": "1995–1996.",
      "D": "2003–2004.",
      "E": "2000–2001.",
      "A": "1988–1989."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 96,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0097",
    "numero": 1597,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "No gráfico seguinte está representado o aumen-\nto progressivo do número de horas de treino \ndiário de um atleta ao longo dos 20 primeiros \ndias do mês de setembro, quando iniciou o trei-\nnamento. \n \n \n \nSe for mantida essa tendência de crescimento, \nno último dia de setembro, o atleta deverá trei-\nnar, diariamente, \n \n \nA) 9 horas e 45 minutos. \nB) 8 horas. \nC) 12 horas. \nD) 9 horas. \nE) 7 horas e 30 minutos.",
    "alternativas": {
      "D": "9 horas.",
      "E": "7 horas e 30 minutos.",
      "A": "9 horas e 45 minutos.",
      "B": "8 horas."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 97,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0098",
    "numero": 1598,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Perfumista é o profissional que desenvolve no-\nvas essências para a indústria de cosméticos. \nConsidere que um perfumista constatou que a \ncombinação de quaisquer três extratos entre os \nde Andiroba, Cupuaçu, Pitanga e Buriti produ-\nzem fragrâncias especiais para a fabricação de \nperfumes. \n \nSimbolizando-se a essência de Andiroba por A, \na de Buriti por B, a de Cupuaçu por C e a de \nPitanga por P, quais são as possíveis combina-\nções dessas essências para a fabricação de \nperfumes, constatadas pelo perfumista? \n \nA) ABC, BCP, CBP. \nB) ACB, BCP, PCA. \nC) ABC, BCP. \nD) ABC, ABP, ACP, BCP. \nE) ACB, BAP, CPA, PAB.",
    "alternativas": {
      "C": "ABC, BCP.",
      "D": "ABC, ABP, ACP, BCP.",
      "A": "ABC, BCP, CBP.",
      "B": "ACB, BCP, PCA."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 98,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0099",
    "numero": 1599,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O esquema a seguir é um modelo de um “reló-\ngio de pingos”, ou seja, um dispositivo que pode \nmarcar o tempo facilmente porque se comporta \nde maneira constante. \n \n \n \nNesse relógio, há um reservatório preenchido \ncom líquido colorido que pinga regularmente, \nmarcando uma fita registradora movida por ci-\nlindros que giram sempre com a mesma veloci-\ndade. Um trecho de 3,6 metros de extensão \ndessa fita registradora é mostrado na figura \nseguinte. \n \n \n \nEsse trecho da fita representa quanto tempo? \n \nA) Exatamente 3,6 minutos \nB) Mais de 1 hora \nC) Mais de 5 minutos \nD) Menos de 1 minuto \nE) Mais de 10 minutos",
    "alternativas": {
      "A": "Exatamente 3,6 minutos",
      "B": "Mais de 1 hora",
      "C": "Mais de 5 minutos",
      "D": "Menos de 1 minuto"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 99,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0100",
    "numero": 1600,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Ao retornarem de avião à sua cidade, 100 pes-\nsoas foram infectadas por um vírus contagioso \nexatamente na hora que desembarcaram na \ncidade. Anteriormente a esse episódio de con-\ntágio, esse vírus não existia na cidade, e sabe-\nse que ele é transmitido em 50% das vezes que \nduas pessoas trocam apertos de mão. Entretan-\nto, o contágio só pode ocorrer entre o momento \nde contágio e 24 horas após esse momento. \n \nConsiderando que as informações do texto es-\ntão corretas e que, em média, as pessoas na \nreferida cidade trocam apertos de mão, em mé-\ndia, 3 vezes por dia, é correto concluir que \n \n \nA) há uma grande probabilidade de que o núme-\nro de contaminados na cidade aumente nos \npróximos dias. \nB) há uma grande probabilidade de que o núme-\nro de contaminados na cidade diminua nos pró-\nximos dias. \nC) há uma grande probabilidade de que o nú-\nmero de contaminados permaneça inalterado \nnos próximos dias. \nD) campanhas para diminuir o número médio de \napertos de mão na cidade para meio por dia não \nseriam efetivas para fazer que o número de \ninfectados caia nos próximos dias. \nE) se o tempo de contágio do vírus fosse de 20 \nhoras em vez de 24 horas, não deverá haver o \naumento de contágio nos próximos dias.",
    "alternativas": {
      "E": "se o tempo de contágio do vírus fosse de 20 horas em vez de 24 horas, não deverá haver o aumento de contágio nos próximos dias.",
      "A": "há uma grande probabilidade de que o núme- ro de contaminados na cidade aumente nos próximos dias.",
      "C": "há uma grande probabilidade de que o nú- mero de contaminados permaneça inalterado nos próximos dias.",
      "D": "campanhas para diminuir o número médio de apertos de mão na cidade para meio por dia não seriam efetivas para fazer que o número de infectados caia nos próximos dias."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 100,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0101",
    "numero": 1601,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O gráfico a seguir mostra o início da trajetória \nde um robô que parte do ponto A (2, 0), movi-\nmentando-se para cima ou para a direita, com \nvelocidade de uma unidade de comprimento por \nsegundo no plano cartesiano. O gráfico exempli-\nfica uma trajetória desse robô, durante 6 segun-\ndos. \n \n \n \nSupondo que esse robô continue essa mesma \ntrajetória, qual será sua coordenada após 18 \nsegundos de caminhada, contando o tempo a \npartir do ponto A? \n \nA) (14, 6) \nB) (6, 14) \nC) (18, 0) \nD) (0, 18) \nE) (18, 2)",
    "alternativas": {
      "A": "(14, 6)",
      "C": "(18, 0)",
      "D": "(0, 18)",
      "E": "(18, 2)"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 101,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0103",
    "numero": 1603,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Determinada empresa fabrica blocos maciços \nno formato de um cubo de lado a, como ilustra a \nfigura a seguir. Devido a exigências do merca-\ndo, a empresa começou a produzir blocos cujos \nlados foram reduzidos pela metade do cubo \noriginal. \n \n \nA fração que expressa a relação entre os volu-\nmes dos cubos maior e menor é \n \nA) 1/8. \nB) 1/2. \nC) 1/64. \nD) 1/4. \nE) 1/16",
    "alternativas": {
      "C": "1/64.",
      "E": "1/16",
      "A": "1/8.",
      "B": "1/2."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 103,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0104",
    "numero": 1604,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Uma empresa constrói peças para jogos no \nformato de cubos e cilindros, nas cores verme-\nlha, azul e verde. No final do dia, o encarregado \nde fazer o controle do estoque coloca todas as \npeças prontas sobre um balcão e começa a \nfazer o controle. Num dia em que a empresa \nproduziu um total de 80 peças, das quais ape-\nnas 25 eram cilindros, o controlador de esto-\nques elaborou os seguintes gráficos. \n \n \n \n \n \nSe o controlador de estoque retirar ao acaso \numa das peças do balcão, a probabilidade de \nessa peça ser vermelha e na forma de cilindro é \nigual a: \n \nA) 1/2 \nB) 1/8 \nC) 5/22 \nD) 32/80 \nE) 25/80",
    "alternativas": {
      "C": "5/22",
      "D": "32/80",
      "A": "1/2",
      "B": "1/8"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 104,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0105",
    "numero": 1605,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "A figura a seguir informa como se constitui o preço da gasolina no Brasil, a partir da extração da matéria-\nprima no fundo do mar, até o produto final nos postos de venda. \n \nDO POÇO À BOMBA \nComo se forma o preço da gasolina no Brasil (por litro) \n \n \n \nConsiderando as informações na figura, desde a prospecção até a comercialização da gasolina, qual o \nfator que, sozinho, representa aproximadamente a metade do preço da gasolina nas bombas? \nA) o imposto \nB) os postos \nC) a distribuição \nD) a extração \nE) as refinarias",
    "alternativas": {
      "A": "o imposto",
      "C": "a distribuição",
      "D": "a extração",
      "E": "as refinarias"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 105,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0106",
    "numero": 1606,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O gráfico a seguir apresenta o lucro, em reais, \nobtido por uma empresa em função da quanti-\ndade de unidades produzidas, quando essa \nquantidade varia entre 0 e 600 unidades. \n \n \n \nUma análise desse gráfico indica que o intervalo \nde unidades produzidas em que a taxa média \nde variação do lucro é positiva ocorre apenas: \n \nA) entre 100 e 300. \nB) entre 200 e 300. \nC) entre zero e 200. \nD) entre 100 e 600. \nE) entre 400 e 600.",
    "alternativas": {
      "A": "entre 100 e 300.",
      "C": "entre zero e 200.",
      "D": "entre 100 e 600.",
      "E": "entre 400 e 600."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 106,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0107",
    "numero": 1607,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O gráfico seguinte mostra o número de focos de \nqueimadas em Goiás, entre 2004 e 2008, sendo \nque o valor relativo a 2008 refere-se somente ao \nperíodo de 1.º de janeiro a 5 de agosto. \n \n \n \nA) 1.032. \nB) 2.184. \n \nC) 1.578. \nD) 819. \nE) 213.",
    "alternativas": {
      "D": "819.",
      "E": "213.",
      "A": "1.032.",
      "B": "2.184."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 107,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0108",
    "numero": 1608,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Membros de uma família estão decidindo como \nirão dispor duas camas em um dos quartos da \ncasa. As camas têm 0,80 m de largura por 2 m \nde comprimento cada. As figuras abaixo ex-\npõem os esboços das ideias sugeridas por Jo-\nsé, Rodrigo e Juliana, respectivamente. Em \ntodos os esboços, as camas ficam afastadas \n0,20 m das paredes e permitem que a porta seja \naberta em pelo menos 90°. \n \n \n \nJosé, Rodrigo e Juliana concordaram que a \nparte listrada em cada caso será de difícil circu-\nlação, e a área branca é de livre circulação.  \n \nEntre essas propostas, a(s) que deixa(m) maior \nárea livre para circulação é(são): \n \nA) as propostas de Rodrigo e Juliana. \nB) a proposta de Rodrigo. \nC) as propostas de José, Rodrigo e Juliana. \nD) a proposta de Juliana. \nE) as propostas de José e Rodrigo.",
    "alternativas": {
      "A": "as propostas de Rodrigo e Juliana.",
      "B": "a proposta de Rodrigo.",
      "C": "as propostas de José, Rodrigo e Juliana.",
      "E": "as propostas de José e Rodrigo."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 108,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0110",
    "numero": 1610,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Um técnico está testando no laboratório de \nQuímica a evaporação de dois líquidos que \npossuem evaporação constante. Para isso, pe-\ngou dois recipientes idênticos que garantiam \nque a área de evaporação não influenciasse no \nprocesso e anotou os seguintes dados no rela-\ntório final. \n \nLíquido 1 - Foram colocados 200 mL e a evapo-\nração completa ocorreu no 80.º dia \n \nLíquido 2 - Foram colocados 180 mL e a evapo-\nração completa ocorreu no 96.º dia. \n \nTerminando essa experiência, o técnico quer \nrepetir o mesmo processo, só que parando no \ndia em que os dois líquidos alcançassem o \nmesmo nível. De acordo com os dados acima, o \ntécnico pode prever que deve parar a experiên-\ncia no: \n \nA) 2.º dia. \nB) 88.º dia. \nC) 176.º dia. \nD) 16.º dia. \nE) 32.º dia.",
    "alternativas": {
      "D": "16.º dia.",
      "E": "32.º dia.",
      "B": "88.º dia.",
      "C": "176.º dia."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 110,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0111",
    "numero": 1611,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Uma editora de jornal tem 7 profissionais res-\nponsáveis pela produção de 35.000 exemplares \ntodos os dias. Após a ocorrência de mortes \ndevido à gripe suína, a procura por informações \na respeito dessa gripe aumentou bastante, e o \njornal teve que aumentar sua produção para \n65.000 por dia. O número de contratações cres-\nce proporcionalmente em relação ao aumento \nno número de exemplares produzidos. \n \nO número de novos funcionários que a editora \nteve que contratar foi: \n \nA) 6. \nB) 13. \nC) 4. \nD) 20. \nE) 11.",
    "alternativas": {
      "D": "20.",
      "E": "11.",
      "A": "6.",
      "C": "4."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 111,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0112",
    "numero": 1612,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Em uma fazenda com 24 porcas matrizes na \nsegunda gestação, todas de mesma idade e \nreproduzindo, foram obtidos os seguintes dados \ncom relação ao número de porquinhos nascido \nvivos. \n \n \nA média ME e a moda MO, dessa distribuição, \ndo número de porquinhos por matriz, são: \n \n \nA) ME = 11 e MO =11. \nB) ME = 11,5 e MO =10. \nC) ME = 11,5 e MO =13. \nD) ME = 11 e MO =10. \nE) ME = 11 e MO =13.",
    "alternativas": {
      "B": "ME = 11,5 e MO =10.",
      "D": "ME = 11 e MO =10.",
      "E": "ME = 11 e MO =13.",
      "A": "ME = 11 e MO =11."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 112,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0113",
    "numero": 1613,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Um tanque está com 100 litros de um líquido \nconstituído de 80% de água e 20% de impure-\nzas diversas e vai começar a receber um trata-\nmento químico de despoluição. Após passar \npelo processo de purificação, a água será ar-\nmazenada em um reservatório à parte. \n \nEm dado momento, o volume de água purificada \nno reservatório indica que, no tanque, 50% do \nlíquido restante é água. Isso indica que, no re-\nservatório, o volume de água, em litros, é igual \na: \n \nA) 50,0. \nB) 60,0. \nC) 90,0. \nD) 80,0. \nE) 12,5.",
    "alternativas": {
      "E": "12,5.",
      "A": "50,0.",
      "B": "60,0.",
      "C": "90,0."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 113,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0114",
    "numero": 1614,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Especialistas do Instituto Internacional de Águas \nde Estocolmo estimam que cada pessoa neces-\nsita de, no mínimo, 1.000 m3 de água por ano, \npara consumo, higiene e cultivo de alimentos. \nSabe-se, também, que o Rio Amazonas despeja \n200.000 m3 de água no mar por segundo. \n \nPor quanto tempo seria necessário coletar as \náguas que o Rio Amazonas despeja no mar \npara manter a população da cidade de São Pau-\nlo, estimada em 20 milhões de pessoas, por um \nano? \n \nA) 16 minutos e 40 segundos. \nB) 1 dia, 3 horas, 46 minutos e 40 segundos. \nC) 11 dias, 13 horas, 46 minutos e 40 segundos. \nD) 3 meses, 25 dias, 17 horas, 46 minutos e 40 \nsegundos. \nE) 2 horas, 46 minutos e 40 segundos.",
    "alternativas": {
      "A": "16 minutos e 40 segundos.",
      "B": "1 dia, 3 horas, 46 minutos e 40 segundos.",
      "C": "11 dias, 13 horas, 46 minutos e 40 segundos.",
      "D": "3 meses, 25 dias, 17 horas, 46 minutos e 40 segundos."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 114,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0116",
    "numero": 1616,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "De acordo com dados do Instituto Brasileiro de \nGeografia e Estatística (IBGE), na relação entre \nas populações masculina e feminina no Brasil, \nobservou-se, em 2000, o total de 97 homens \npara 100 mulheres. Para 2050, espera-se que a \nrazão entre a população masculina e a feminina \nfique em torno de 94%, isto é, em cada grupo \nde 100 mulheres haverá 6 excedentes em rela-\nção à quantidade de homens. Dessa forma, \nestimou-se que, em 2050, o excedente feminino \nna população total poderá atingir 7 milhões de \nmulheres. \n \nEsses dados indicam que a população brasileira \ntotal em 2050, distribuída por sexo, poderá atin-\ngir cerca de: \n \nA) 106 milhões de mulheres e 94 milhões de \nhomens. \nB) 116 milhões de mulheres e 109 milhões de \nhomens. \nC) 116 milhões de mulheres e 97 milhões de \nhomens. \nD) 104 milhões de mulheres e 97 milhões de \nhomens. \nE) 106 milhões de mulheres e 97 milhões de \nhomens.",
    "alternativas": {
      "D": "104 milhões de mulheres e 97 milhões de homens.",
      "E": "106 milhões de mulheres e 97 milhões de homens.",
      "A": "106 milhões de mulheres e 94 milhões de homens.",
      "B": "116 milhões de mulheres e 109 milhões de homens."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 116,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0117",
    "numero": 1617,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Certo hotel tem duas piscinas, sendo uma com \n1,20 m de profundidade, e uma infantil com \nprofundidade de 40 cm. Os formatos das duas \nsão idênticos e dados na figura seguinte. A bor-\nda AB mede o triplo da borda correspondente \nna piscina menor. \n \n \nO fundo da piscina maior tem o formato da figu-\nra ABCDE e o fundo da piscina menor é uma \nfigura semelhante a essa figura ABCDE. Então \na capacidade da piscina maior é: \n \nA) 27 vezes a capacidade da piscina menor. \nB) 3 vezes a capacidade da piscina menor. \nC) 9 vezes a capacidade da piscina menor. \nD) 1,2 vezes a capacidade da piscina menor. \nE) 3,6 vezes a capacidade da piscina menor.",
    "alternativas": {
      "A": "27 vezes a capacidade da piscina menor.",
      "B": "3 vezes a capacidade da piscina menor.",
      "D": "1,2 vezes a capacidade da piscina menor.",
      "E": "3,6 vezes a capacidade da piscina menor."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 117,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0118",
    "numero": 1618,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Uma empresa vendia, por mês, 200 unidades \nde certo produto ao preço de R$ 40,00 a unida-\nde. A empresa passou a conceder desconto na \nvenda desse produto e verificou-se que a cada \nreal de desconto concedido por unidade do pro-\nduto implicava na venda de 10 unidades a mais \npor mês. \n \nPara obter o faturamento máximo em um mês, o \nvalor do desconto, por unidade do produto, deve \nser igual a: \n \nA) R$ 5,00. \nB) R$ 15,00. \nC) R$ 10,00. \nD) R$ 12,00. \nE) R$ 20,00.",
    "alternativas": {
      "E": "R$ 20,00.",
      "A": "R$ 5,00.",
      "B": "R$ 15,00.",
      "C": "R$ 10,00."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 118,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0119",
    "numero": 1619,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O Sol é uma fantástica fonte de energia para \nnosso planeta, haja vista que 40 minutos de \nincidência de energia proveniente do Sol é equi-\nvalente ao consumo anual de energia do mun-\ndo. Nos Estados Unidos, pelo menos 640 km2 \nsomente no sudoeste são propícios à constru-\nção de usinas de energia solar, e essa área \nrecebe 1,134 quatrilhão de quilocalorias de ra-\ndiação solar por ano. Se somente 2,5% dessa \nradiação fossem convertidos em energia elétri-\nca, seria o suficiente para suprir o consumo total \nde energia dos Estados Unidos no ano de 2006. \n \nAtualmente as células fotovoltaicas, que conver-\ntem energia solar em elétrica, possuem um ren-\ndimento de 10%, correspondente à fração da \nenergia coletada pela energia recebida. Qual \nseria, em km2, a área da região do sudoeste \namericano que seria necessário preencher com \ncélulas fotovoltaicas para suprir a demanda \nenergética dos Estados Unidos em 2006? \n  \nA) 576 \nB) 480 \nC) 16 \nD) 160 \nE) 64",
    "alternativas": {
      "D": "160",
      "A": "576",
      "B": "480",
      "C": "16"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 119,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0120",
    "numero": 1620,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Uma operadora de telefonia celular oferece o \nseguinte plano no sistema pós-pago: valor fixo \nde R$ 60,00 por mês para até 80 minutos de \nligações locais e, para cada minuto excedente, \nserá cobrado o valor de R$ 1,20. \n \nSe P é o valor a ser pago em um mês e t o total \nde minutos utilizados em ligações locais, qual a \nexpressão que permite calcular, em reais, a \nconta de uma pessoa que utilizou o telefone por \nmais de 80 minutos? \n \nA) P = 1,20t - 36 \nB) P = 1,20t + 60 \nC) P = 1,20t - 60 \nD) P = 1,20t - 96 \nE) P = 1,20t + 36",
    "alternativas": {
      "E": "P = 1,20t + 36",
      "A": "P = 1,20t - 36",
      "C": "P = 1,20t - 60",
      "D": "P = 1,20t - 96"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 120,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0121",
    "numero": 1621,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "A tabela seguinte mostra a frequência de aci-\ndentes com vítimas fatais envolvendo motocicle-\ntas no Distrito Federal, durante o ano de 2007, \nde acordo com o dia da semana e o horário. \n \n \n \nEm relação ao total de acidentes, a razão entre \na probabilidade de ocorrência de um acidente \ncom vítima fatal em uma sexta-feira ou num \nsábado e, essa mesma probabilidade para uma \nterça-feira, é igual a: \n \nA) 3 \nB) 1/3 \nC) 1 \nD) 1/2 \nE) 2",
    "alternativas": {
      "A": "3",
      "C": "1",
      "D": "1/2",
      "E": "2"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 121,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0122",
    "numero": 1622,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O gráfico abaixo mostra a área colhida, em mi-\nlhares de hectares, e a quantidade, em milhares \nde toneladas, de cana-de-açúcar produzida no \nBrasil, no período de 2000 a 2007. \n \n \n \nDe acordo como o gráfico, em 2004, a produti-\nvidade, quantidade de toneladas produzidas de \ncana-de-açúcar por hectare, foi: \n \nA) inferior a 80 toneladas. \nB) superior a 110 toneladas e inferior a quanti-\ndade de 220 toneladas. \nC) superior a 360 toneladas. \nD) superior a 80 toneladas e inferior a quantida-\nde de 110 toneladas. \nE) superior 220 toneladas a e inferior a quanti-\ndade de 360 toneladas.",
    "alternativas": {
      "B": "superior a 110 toneladas e inferior a quanti- dade de 220 toneladas.",
      "D": "superior a 80 toneladas e inferior a quantida- de de 110 toneladas.",
      "E": "superior 220 toneladas a e inferior a quanti- dade de 360 toneladas.",
      "A": "inferior a 80 toneladas."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 122,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0123",
    "numero": 1623,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Uma propriedade rural tem a forma mostrada na \nfigura a seguir, em que os segmentos PQ e QR \nsão perpendiculares entre si. Suponha que, \nentre os pontos P e Q, passa um córrego retilí-\nneo de largura inferior a 10 m, e entre os pontos \nQ e R passa um rio retilíneo de largura entre 15 \nm e 25 m. A legislação estabelece como Área \nde Preservação Permanente (APP) uma faixa \nmarginal de 30 m de largura para cursos de \nágua com menos de 10 m de largura, e uma \nfaixa marginal de 50 m para cursos de água de \n10 m a 50 m de largura. \nCom base nas informações do texto e na figura, qual deve ser a Área de Preservação Permanente dessa \npropriedade rural? \n \nA) 10.500 m2 \nB) 18.000 m2 \nC) 3.000 m2 \nD) 12.000 m2 \nE) 5.400 m2",
    "alternativas": {
      "C": "3.000 m2",
      "E": "5.400 m2",
      "A": "10.500 m2",
      "B": "18.000 m2"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 123,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0124",
    "numero": 1624,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "No período do Brasil Colônia, a Coroa Portuguesa desenvolveu várias políticas de exploração do seu \nterritório. Ao longo de trezentos anos, foram realizadas muitas atividades exploratórias. No século XVIII, \nmovida pelas expedições Bandeiras e pela expansão territorial, a província de Minas Gerais alcançou o \nauge na mineração de ouro. O gráfico a seguir mostra a evolução da produção de ouro nos estados de \nMato Grosso (MT), Goiás (GO) e Minas Gerais (MG) entre os anos de 1705 e 1799. \n \n \n \nO apogeu da mineração de ouro no Brasil ocorreu no período 1739-1754. A taxa média de crescimento \nanual neste período foi de: \n \nA) 14,7%. \nB) 56,7%. \nC) 11,3%. \nD) 42,5%. \nE) 3,92%.",
    "alternativas": {
      "B": "56,7%.",
      "C": "11,3%.",
      "D": "42,5%.",
      "A": "14,7%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 124,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0125",
    "numero": 1625,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Mauritus Cornelis Escher, em alguns de seus \ntrabalhos utilizava uma malha de polígonos \nregulares. A partir dessa malha, Escher fazia \nmudanças nos polígonos, sem alterar a área do \npolígono original. Assim surgiam figuras de ho-\nmens, aves, peixes e lagartos que formavam \nmosaicos representados num plano bidimensio-\nnal. \n \n \nConsiderando as informações do texto e as \nfiguras acima e que o lado do hexágono mede 2 \ncm e que √3 = 1,7, pode-se revestir, aproxima-\ndamente, \n \nA) uma parede retangular de 4 m x 2 m com \n47.058 lagartos. \nB) um mural retangular de 2 m x 1 m com 19 \nlagartos. \nC) um vitral hexagonal regular com lado de 5 m \ncom 62.500 lagartos. \nD) uma vela de barco de 15 m² com 14.691 \nlagartos. \nE) um quadro retangular de 1 m x 0,8 m com 47 \nlagartos.",
    "alternativas": {
      "D": "uma vela de barco de 15 m² com 14.691 lagartos.",
      "E": "um quadro retangular de 1 m x 0,8 m com 47 lagartos.",
      "B": "um mural retangular de 2 m x 1 m com 19 lagartos.",
      "C": "um vitral hexagonal regular com lado de 5 m com 62.500 lagartos."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 125,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0126",
    "numero": 1626,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "A tabela a seguir mostra a evolução da popula-\nção da região Nordeste do Brasil, em milhões \nde habitantes, em alguns anos entre o final do \nséculo XIX e o final do século XX. \n \n \n \nUtilizando-se uma escala decenal na qual o ano \n1890 corresponde ao decênio 1, 1900 corres-\nponde ao decênio 2, etc., então a população da \nregião Nordeste ultrapassou os 30 milhões de \nhabitantes após o decênio: \n \nA) 8. \nB) 9. \nC) 10. \nD) 6. \nE) 7.",
    "alternativas": {
      "A": "8.",
      "B": "9.",
      "D": "6.",
      "E": "7."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 126,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0127",
    "numero": 1627,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O planeta terra possui em torno de 11,4 bilhões \nde hectares de terra e mar produtivos, capazes \nde fornecer suprimento para a população mun-\ndial. Se divididos pelos 6,5 bilhões de habitan-\ntes, deixam uma média de 1,8 hectare por pes-\nsoa. Para medir o impacto das nações sobre os \nrecursos naturais do planeta, a pegada ecológi-\nca de cada país mostra o quanto de espaço no \nterritório é necessário para suprir os hábitos de \nconsumo de cada habitante. \n \n \nDe acordo com os dados apresentados no texto \ne na tabela, a porcentagem que a média das \npegadas ecológicas dos países (da tabela) é \nmaior que a média mundial é aproximadamente: \n \nA) 261%. \nB) 142%. \nC) 242%. \nD) 361%. \nE) 42%.",
    "alternativas": {
      "B": "142%.",
      "D": "361%.",
      "E": "42%.",
      "A": "261%."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 127,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0128",
    "numero": 1628,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Uma empresa de transporte escolar, após ma-\npear o local onde vai atuar, analisa os possíveis \ntrajetos buscando minimizar o percurso desde a \ngaragem (G), pegando os alunos (A1, A2,..., A5) \nem suas residências, levando-os à faculdade (F) \ne, depois das aulas, trazendo-os de volta para \nsuas residências. O mapa abaixo mostra as \nruas, os pontos onde se localizam a garagem, \nas esquinas com pontos de parada para pegar \nos alunos e a faculdade. \n \n \n \nAs ruas, perpendiculares e(ou) paralelas, com \nas paralelas a 400 metros uma da outra, permi-\ntem o tráfego nos dois sentidos. Saindo da ga-\nragem G, pegando os alunos, levando-os à fa-\nculdade F e fazendo o mesmo percurso na vol-\nta, o menor percurso total medirá: \n \nA) 16,8 km. \nB) 8,4 km. \nC) 4,8 km. \nD) 3,6 km. \nE) 7,2 km.",
    "alternativas": {
      "E": "7,2 km.",
      "A": "16,8 km.",
      "B": "8,4 km.",
      "C": "4,8 km."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 128,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0129",
    "numero": 1629,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Carros de motor a álcool ou a gasolina poluem \nde maneiras diferenciadas. Considere que cada \nlitro de álcool consumido no motor corresponde \na retirar 6,5 kg de CO2 (gás carbônico) e injetar \nna atmosfera 4,7 kg de O2 (gás oxigênio), en-\nquanto cada litro de gasolina consumida no \nmotor retira 2,6 kg de O2 da atmosfera e lança \n2,3 kg de CO2. Suponha, ainda, que uma cidade \npossua uma frota de 20.000 veículos, sendo \nmetade dos veículos movidos a álcool e que \ncada veículo a gasolina consome, em média, \n2.000 litros de gasolina por ano, enquanto cada \nveículo a álcool consome, em média, 2.800 \nlitros a mais de álcool. \nDe acordo com o texto, o consumo anual de \ncombustível da frota de veículos daquela cidade \ncorresponde a: \n \nA) retirar 136.000 kg de CO2 da atmosfera e \ninjetar 7.960 kg de O2. \nB) retirar 84.000.000 kg de CO2 da atmosfera e \ninjetar 42.600.000 kg de O2. \nC) retirar 42.000 kg de CO2 da atmosfera e inje-\ntar 21.000 kg de O2. \nD) retirar 228.000.000 kg de CO2 da atmosfera e \ninjetar 183.600.000 kg de O2. \nE) retirar 136.000.000 kg de CO2 da atmosfera e \ninjetar 79.600.000 kg de O2.",
    "alternativas": {
      "C": "retirar 42.000 kg de CO2 da atmosfera e inje- tar 21.000 kg de O2.",
      "D": "retirar 228.000.000 kg de CO2 da atmosfera e injetar 183.600.000 kg de O2.",
      "E": "retirar 136.000.000 kg de CO2 da atmosfera e injetar 79.600.000 kg de O2.",
      "B": "retirar 84.000.000 kg de CO2 da atmosfera e injetar 42.600.000 kg de O2."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 129,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];